import $ from "jquery";
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import {
    getDraftSkillsById,
    addSkillFromStore,
    changeActiveTab,
  } from "../../../../redux/actions/skill";
import { notify } from "../../../../redux/actions/snack";
import { isValidHttpUrl } from "../../../../utility";

const SkillOnboard = () => {

  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const [onboardUrl, setOnboardUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
    
  useEffect(() => {
    addToMySkills(params.id)
  }, []);

  const addToMySkillsWithURL = async (skillId) => {
    
    if (!isValidHttpUrl(onboardUrl)) {
      dispatch(notify("error", "Please enter valid url"));
      return;
    }
    setIsLoading(true);
    let skillDetail = await dispatch(getDraftSkillsById(skillId));
    let onboardSkillInfo = {
      skillId: skillId,
      skillMeta: {
        Type: "draft_skill",
        Template: skillDetail?.data?.data?.TEMPLATE,
        URL: onboardUrl,
      },
      skillName: skillDetail?.data?.data?.SKILL_NAME,
    };
    await dispatch(addSkillFromStore(onboardSkillInfo));
    dispatch(
      notify("success", "Agent added successfully. Go to 'AI Agents' Added From Agent Hub section")

    );
  
    history.push(`/dashboard/skills/published`);
    dispatch(changeActiveTab("Added From Agent Hub"));
  }

  const addToMySkills = async (skillId) => {
    
    let skillDetail = await dispatch(getDraftSkillsById(skillId));
    
    if(skillDetail?.data?.data?.TYPE === "SkillHub" && skillDetail?.data?.data?.status === "approved") {
      if (skillDetail?.data?.data?.onboarding_url == false || skillDetail?.data?.data?.onboarding_url == null) {
        let url;
        skillDetail?.data?.data?.FORMATED_DATA?.actions &&
          Object.values(
            skillDetail?.data?.data?.FORMATED_DATA?.actions
          ).forEach((s) => {
            if (s.type === "OPEN_WEB_PAGE") {
              url = s.url;
            }
          });
        let onboardSkillInfo = {
          skillId: skillId,
          skillMeta: {
            Type: "draft_skill",
            Template: skillDetail?.data?.data?.TEMPLATE,
            URL: url,
          },
          skillName: skillDetail?.data?.data?.SKILL_NAME,
        };
        await dispatch(addSkillFromStore(onboardSkillInfo));
       
        dispatch(
          notify("success", "Agent added successfully. Go to 'AI Agents' Added From Agent Hub section")

        );
      
        history.push(`/dashboard/skills/published`);
        dispatch(changeActiveTab("Added From Agent Hub"));
      } else {
        $("#publishModal").show();
      }
    } else {
      window.location.href = "/dashboard/skills/unauthorised";
    }
  };

  return (
      
    <div className="template-flex">
        <div className="skill-home scrollable">
          <div
            id="publishModal"
            class="modal fade crt-skill"
            role="dialog"
            data-backdrop="static"
            data-keyboard="false"
            >
            <div class="modal-dialog ">
              <div class="modal-content crt-content ">
                  <div className="modal-header">
                  <h4 className="modal-title">Add a new skill </h4>
                  </div>
                  <div class="modal-body">
                      <div className="form-contain text-center">
                      <p>
                          Enter skill onboarding URL
                      </p>
                      <div className="flex-social">
                          <div style={{ marginBottom: "15px" }}>
                          
                          <input
                              type="text"
                              name="URL"
                              placeholder="Onboarding URL"
                              onChange={(e) => {
                                  setOnboardUrl(e.target.value);
                              }}
                              value = {onboardUrl}
                          /> 
                          </div>
                      </div>

                      <div>
                          <button
                          className="btn btn-primary"
                          onClick={() => {
                            addToMySkillsWithURL(params.id)
                          }}
                          data-dismiss="modal"
                          >{isLoading ? "Adding.. Please wait" : "Publish"}
                          </button>
                      </div>
                      </div>
                  
                  </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    
  );
};

export default SkillOnboard;